const contributorRoles = {
	NARRATOR: "narrator",
	AUTHOR: "author",
	TRANSLATOR: "translator",
};

export default contributorRoles;
